module.exports = __webpack_public_path__ + "assets/select-lock.436eb95a.svg";